// @core/api/endpoints/activity/list_inbox.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListInboxResponse,
} from '../../../types/activity';

const BASE_PATH = '/activity';

/**
 * List inbox items
 * Returns the current user's Inbox: unacknowledged activities grouped by the entity they relate to. Supports filtering by category (decisions, assignments, mentions, etc.) and pagination.
 */
export async function ListInbox(
  params?: {
    cursor?: string | number | boolean;
    direction?: string | number | boolean;
    filter?: string | number | boolean;
    limit?: string | number | boolean;
    scope?: string | number | boolean;
    scope_id?: string | number | boolean;
    sort?: string | number | boolean;
  },
  options?: RequestOptions
): Promise<ListInboxResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/inbox`;
  const requestOptions = options;
  return client.get<ListInboxResponse>(requestPath, { ...requestOptions, params });
}
